(function(){

    angular.module('tmx-app').directive('tmxKendoFooter',['tmxUtility',tmxKendoFooter]);

    var exists;
    function tmxKendoFooter(tmxUtility){
        var directive={
            restrict:'A',
            link:footerCtrl
        };
        exists=tmxUtility.exists;
        var options;
        function footerCtrl($scope,$elem,$attrs){
            var elem=$elem;
            var scope=$scope;
            var attrs=$attrs;

            function onDataBound(arg){
                var grid=arg.sender;
                var dataSource=grid.dataSource;
                var totalPages=Math.ceil(dataSource.total()/dataSource.pageSize());
                var fdata=new footerData(dataSource.total(),totalPages, dataSource.page(), dataSource.pageSize());
                var footerContainer=grid.wrapper.find(".k-grid-pager");
                if(footerContainer.length>0){//footer already exists
                    empty(footerContainer[0]);					
                }
                else{
                    footerContainer= grid.wrapper.append(makeNewFooterContainer()).find(".k-grid-pager");
                }


                var next=getPageAnchor("tmx-kendo-pager-next","arrow_right",true,"next","tmx-kendo-footer-icons","padding-left:12.5px");
                var prev=getPageAnchor("tmx-kendo-pager-prev","arrow_left",true,"prev","tmx-kendo-footer-icons","padding-right:12.5px");
                var first=getPageAnchor("tmx-kendo-pager-first","arrow_first",true,"first","tmx-kendo-footer-icons","transform: rotate(180deg);");
                var last=getPageAnchor("tmx-kendo-pager-last","arrow_last",true,"last","tmx-kendo-footer-icons");
				//Onclicks for each button
                function goToNext(){
                    if(dataSource.page() + 1 <= totalPages)// no more than last page
                        dataSource.page(dataSource.page() + 1);
                }
                function goToPrevious(){
                    if(dataSource.page() - 1 >= 1 )// at least first page
                        dataSource.page(dataSource.page() - 1);
                }
                function goToFirst(){
                    if(dataSource.page()>1)// greater than first page
                        dataSource.page(1);
                }
                function goToLast(){
                    if(dataSource.page()<totalPages)// less than last page
                        dataSource.page(totalPages);
                }				

				//Add all buttons to footer
                footerContainer.append(last);
                footerContainer.append(next);
                footerContainer.append(prev);
                footerContainer.append(first);
				
                footerContainer.append("<span style='float:right; color: #BDBDBD; padding-right:50px; padding-top: 4px;'>"+fdata.getLine()+"</span>");
				
				//Register their onclick events
                footerContainer.delegate("#tmx-kendo-pager-next",'click',goToNext);
                footerContainer.delegate("#tmx-kendo-pager-prev",'click',goToPrevious);
                footerContainer.delegate("#tmx-kendo-pager-first",'click',goToFirst);	
                footerContainer.delegate("#tmx-kendo-pager-last",'click',goToLast);	
            }

            function error(arg){
            }

            options=tmxUtility.resolveAttr($scope.$parent.$parent,$attrs.options);
            if(!exists(options)) 
                options=tmxUtility.resolveAttr($scope.$parent,$attrs.options);
            if(!exists(options.dataBound)){
                options.dataBound=onDataBound;
				// options.dataSource.transport.error=error;
            }

        }

        return directive;
    }

    function footerData(items,pages,page,pageSize){
        var footer=this;
        footer.items=items;
        footer.pages=pages;
        footer.page=page;
        footer.pageSize=pageSize;
        footer.getLine=function(){
            var lastItem=footer.pageSize*footer.page;
            if(lastItem>items){
                lastItem=items;
            }
            var firstItem=lastItem-footer.pageSize+1;
            var line=items+" items found, displaying "+firstItem+" to "+lastItem+".";
            return line;
        }
    }

    function getPageAnchor(id,content,hasIcon,title,classes,style){
        var anchorStart="<a href='' title='"+title+"' id='"+id+"' class = '"+classes+"' >";
        var anchorClose="</a>"
        var body="";
        if(!(exists(style))) style="";
        if(exists(hasIcon) && hasIcon){
            body+="<img class='md-accent material-icons' style='"+style+"' src='assets/images/"+content+".svg' >";
        }
        else{
            body+=content;
        }
        return anchorStart+body+anchorClose;
    }

    function makeNewFooterContainer(){
        var containerDiv='<div class="k-pager-wrap k-grid-pager k-widget k-floatwrap" data-role="pager"> </div>';
        return containerDiv;
    }

    function empty(node){
        while (node.firstChild) {
            node.removeChild(node.firstChild);
        }
    }
})();